import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosPropietarios = ({ propietarios, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Propietarios")}
            eyebrow={t("Empresa")}
            imagen={propietarios.imagen_cabecera ? ruta + "/" + propietarios.imagen_cabecera : null}
            html={propietarios.ladesc}
        />
    );
}

export default TextosPropietarios;
